import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { deleteParserTest } from '../api'
import { ParserTest } from '../types'

interface IParserTestConfirmationModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onClose: () => void
  onSuccess: () => void
  selectedParserTest?: ParserTest
}

export const ParserTestConfirmationModal = ({
  onClose,
  onSuccess,
  selectedParserTest,
  ...props
}: IParserTestConfirmationModalProps) => {
  const confirmDeleteHandler = async () => {
    await deleteParserTest(selectedParserTest?.id || 0)
    onClose()
    onSuccess()
  }

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Confirm',
      action: confirmDeleteHandler,
      type: 'confirm',
      dataTest: 'confirm-button',
    },
    {
      label: 'Cancel',
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      onClose={onClose}
      dataTest='ParserTestConfirmationModal'
      modalType={MODAL_TYPES.confirmation}
      size={4}
      open
      title='Are you sure you want to delete this parser Test?'
      actions={actions}
      {...props}
    />
  )
}
